export default __webpack_public_path__ + "static/media/l22-grey.bccc66e9.svg";